import { getUrlQueryParam } from './urlQueryStringUtils';

function buildFormData(payload) {
  const formData = new FormData();

  Object.keys(payload).forEach((prop) => {
    formData.append(prop, payload[prop]);
  });

  return formData;
}

function overParseJson(jsonString) {
  const json = JSON.parse(jsonString);
  if (typeof json === 'object') return json;
  return JSON.parse(json);
}

function buildQueryString(payload) {
  return Object.keys(payload).map(param => `${param}=${payload[param]}`).join('&');
}

async function checkAttendantAndFetch(url = '', opts = {}) {
  try {
    let finalUrl = url;
    const userId = getUrlQueryParam('userId');
    if (userId) {
      finalUrl = new URL(url);
      finalUrl.searchParams.set('userId', userId);
      finalUrl = finalUrl.href;
    }
    return await fetch(finalUrl, opts);
  } catch (e) {
    throw e;
  }
}

export {
  buildFormData,
  overParseJson,
  buildQueryString,
  checkAttendantAndFetch,
};
